// extracted by mini-css-extract-plugin
export default {"root":"Main_root__slkAg","pageOrb":"Main_pageOrb__ktUHk","pageOrbG":"Main_pageOrbG__6VqwF","pageOrbR":"Main_pageOrbR__YqLvP"};